// extracted by mini-css-extract-plugin
export default {"content":"mainLayout_content__LuZCv","container":"mainLayout_container__kxA7k","mensagem":"mainLayout_mensagem__xYbMh"};